import { InstanceScreen } from 'component/navigation/instance';

export default function SettingsIndexScreen() {
    return <InstanceScreen />;
}
